import AgoraRTC from './AgoraEnhancer';
import VirtualBackgroundExtension from 'agora-extension-virtual-background';
import videoBack from '~/assets/images/background_video.jpg';

// Extensao registrada uma unica vez (singleton do agora-rtc-sdk-ng).
let extension = null;
// Imagem de fundo carregada uma vez e reaproveitada.
let backgroundPromise = null;

function getExtension() {
  if (!extension) {
    extension = new VirtualBackgroundExtension();
    AgoraRTC.registerExtensions([extension]);
  }
  return extension;
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

// Fundo padrao da empresa: imagem branded da Televida (background_video.jpg, 1280x720 otimizado).
function getBackground() {
  if (!backgroundPromise) backgroundPromise = loadImage(videoBack);
  return backgroundPromise;
}

/**
 * Aplica o fundo virtual padrao (imagem branded da Televida) ao track de video local.
 * Pensado para o operador do admin (atendente/admin/medico) — nunca no paciente.
 * Tolerante a falha: se o navegador nao suportar, segue sem fundo.
 * @returns {Promise<object|null>} o processor (para release) ou null.
 */
export async function applyVirtualBackground(videoTrack) {
  if (!videoTrack) return null;

  const ext = getExtension();
  if (!ext.checkCompatibility()) {
    console.warn('[VirtualBackground] navegador sem suporte — seguindo sem fundo.');
    return null;
  }

  try {
    const processor = ext.createProcessor();
    await processor.init();

    videoTrack.pipe(processor).pipe(videoTrack.processorDestination);

    const source = await getBackground();
    processor.setOptions({ type: 'img', source });
    await processor.enable();

    return processor;
  } catch (err) {
    console.error('[VirtualBackground] falha ao aplicar fundo:', err);
    return null;
  }
}
